import styled from 'styled-components';
import { getDragColors } from '../utils/dragAndDropHelpers';

export const DropZoneContainer = styled.div`
  width: 100%;
  padding: ${props => (props.theme.spacing && props.theme.spacing.xl) || '32px'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: ${props => (props.theme.radii && props.theme.radii.lg) || '8px'};
  border: 2px dashed;
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  ${props => {
    const colors = getDragColors(props.isDragging, props.theme);
    return `
      background-color: ${colors.bg};
      border-color: ${colors.border};
      color: ${colors.text};
    `;
  }}

  &:hover {
    background-color: ${props => {
      const colors = getDragColors(true, props.theme);
      return !props.isDragging ? colors.bg : 'inherit';
    }};
  }
`;

export const DropZoneIcon = styled.div`
  font-size: 32px;
  margin-bottom: ${props => (props.theme.spacing && props.theme.spacing.sm) || '12px'};
  color: inherit;
`;

export const DropZoneText = styled.div`
  font-family: ${props => (props.theme.typography && props.theme.typography.fontFamily && props.theme.typography.fontFamily.base) || 'sans-serif'};
  font-size: ${props => (props.theme.typography && props.theme.typography.fontSize && props.theme.typography.fontSize.md) || '16px'};
  font-weight: 500;
  text-align: center;
  color: inherit;
`;

export const DropZoneSubText = styled.div`
  font-family: ${props => (props.theme.typography && props.theme.typography.fontFamily && props.theme.typography.fontFamily.base) || 'sans-serif'};
  font-size: ${props => (props.theme.typography && props.theme.typography.fontSize && props.theme.typography.fontSize.sm) || '14px'};
  color: ${props => (props.theme.colors && props.theme.colors.text && props.theme.colors.text.muted) || '#6c757d'};
  text-align: center;
  margin-top: 4px;
`;

export const HiddenInput = styled.input`
  display: none;
`;



// WEBPACK FOOTER //
// ./src/design-system/molecules/DragAndDrop/components/DragAndDropStyles.js